import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost } from "../../services/httpService";
import {
  addCompanyDocumentUrl,
  getCompanyDocumentsByCompanyId,
  getDocumentsAnalyticsByCompanyId,
  addCompanyFolderUrl,
  renameCompanyFolderUrl,
  getCompanyFoldersByCompanyIdUrl,
  getDocumentsOverallCompliancesByCompanyIdUrl,
  getDocumentsMembersCompliancesByCompanyIdUrl,
  viewCompanyDocumentUrl,
  getCompayDocumentById,
  updateCompanyDocumentUrl,
  getAllCompanyDocumentsByCompanyId,
  deleteCompanyDocumentsUrl,
  deleteCompanyFolderUrl,
  getCompanyDocumentsByCompanyIdAndEmailUrl,
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";

const initialState = {
  isCompanyDocumentAdded: false,
  isCompanyDocumentsLoading: false,
  isAddDocumentLoading: false,
  companyDocumentsData: [],
  isDocumentsAnalyticsLoading: false,
  documentsAnalytics: null,
  companyFoldersLoader: false,
  isRenameCompanyFolderLoading: false,
  companyFolders: [],
  isDocumentsOverallComplianceLoading: false,
  documentsOverallCompliance: null,
  isDocumentsMembersComplianceLoading: false,
  documentsMembersCompliance: null,
  viewDocumentLoader: false,
  isGetAllCompanyDocumentsLoading: false,
  allCompanyDocuments: null,
  isGetCompayDocumentByIdLoading: false,
  patientCompanyDocument: null,
  isDeleteCompanyDocumentsLoading: false,
  deleteCompanyDocuments: null,
  companyUserDocumentsData: [],
};

export const addCompanyDocumentData = createAsyncThunk(
  "CompanyDocument/addCompanyDocumentData",
  async (data) => {
    const url = addCompanyDocumentUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getCompanyDocumentsByCompanyIdData = createAsyncThunk(
  "CompanyDocument/getCompanyDocumentsByCompanyIdData",
  async (companyID) => {
    const url = getCompanyDocumentsByCompanyId(companyID);
    const respData = await httpGet(url);
    return respData;
  },
);

export const getCompanyDocumentsByCompanyIdAndEmailData = createAsyncThunk(
  "CompanyDocument/getCompanyDocumentsByCompanyIdAndEmailData",
  async (companyID) => {
    const url = getCompanyDocumentsByCompanyIdAndEmailUrl(companyID);
    const respData = await httpGet(url);
    return respData;
  },
);
export const getAllCompanyDocumentsByCompanyIdData = createAsyncThunk(
  "CompanyDocument/getAllCompanyDocumentsByCompanyIdData",
  async (companyID) => {
    const url = getAllCompanyDocumentsByCompanyId(companyID);
    const respData = await httpGet(url);
    return respData;
  },
);

export const addCompanyFolderData = createAsyncThunk(
  "CompanyDocument/addCompanyFolderData",
  async (data) => {
    const url = addCompanyFolderUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const renameCompanyFolderData = createAsyncThunk(
  "CompanyDocument/renameCompanyFolderData",
  async (data) => {
    const url = renameCompanyFolderUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getCompanyFoldersByCompanyIdData = createAsyncThunk(
  "CompanyDocument/getCompanyFoldersByCompanyIdData",
  async (companyID) => {
    const url = getCompanyFoldersByCompanyIdUrl(companyID);
    const respData = await httpGet(url);
    return respData;
  },
);

export const getDocumentsAnalyticsByCompanyIdData = createAsyncThunk(
  "CompanyDocument/getDocumentsAnalyticsByCompanyIdData",
  async (companyID) => {
    const url = getDocumentsAnalyticsByCompanyId(companyID);
    const respData = await httpGet(url);
    return respData;
  },
);

export const getDocumentsOverallCompliancesByCompanyIdData = createAsyncThunk(
  "CompanyDocument/getDocumentsOverallCompliancesByCompanyIdData",
  async (companyID) => {
    const url = getDocumentsOverallCompliancesByCompanyIdUrl(companyID);
    const respData = await httpGet(url);
    return respData;
  },
);

export const getDocumentsMembersCompliancesByCompanyIdData = createAsyncThunk(
  "CompanyDocument/getDocumentsMembersCompliancesByCompanyIdData",
  async (companyID) => {
    const url = getDocumentsMembersCompliancesByCompanyIdUrl(companyID);
    const respData = await httpGet(url);
    return respData;
  },
);

export const viewCompanyDocumentData = createAsyncThunk(
  "CompanyDocument/viewCompanyDocumentData",
  async (data) => {
    const url = viewCompanyDocumentUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getCompayDocumentByIdData = createAsyncThunk(
  "CompanyDocument/getCompayDocumentByIdData",
  async (docId) => {
    const url = getCompayDocumentById(docId);
    const respData = await httpGet(url);
    return respData;
  },
);

export const updateCompanyDocumentData = createAsyncThunk(
  "CompanyDocument/updateCompanyDocumentData",
  async (data) => {
    const url = updateCompanyDocumentUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const deleteCompanyDocumentsData = createAsyncThunk(
  "CompanyDocument/deleteCompanyDocumentsData",
  async (data) => {
    const url = deleteCompanyDocumentsUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const deleteCompanyFolderData = createAsyncThunk(
  "CompanyDocument/deleteCompanyFolderData",
  async (data) => {
    const url = deleteCompanyFolderUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

const companyDocumentSlice = createSlice({
  name: "companyDocument",
  initialState,
  reducers: {
    setIsCompanyDocumentLoadingData: (state, action) => {
      state.isCompanyDocumentsLoading = action?.payload || false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCompanyDocumentData.pending, (state) => {
        state.isAddDocumentLoading = true;
      })
      .addCase(addCompanyDocumentData.fulfilled, (state, action) => {
        state.isAddDocumentLoading = false;
        state.isCompanyDocumentAdded = action?.payload;
      })
      .addCase(addCompanyDocumentData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isAddDocumentLoading = false;
      })
      .addCase(getCompanyDocumentsByCompanyIdData.pending, (state) => {
        state.isCompanyDocumentsLoading = true;
      })
      .addCase(
        getCompanyDocumentsByCompanyIdData.fulfilled,
        (state, action) => {
          state.isCompanyDocumentsLoading = false;
          state.companyDocumentsData = action?.payload;
        },
      )
      .addCase(getCompanyDocumentsByCompanyIdData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isCompanyDocumentsLoading = false;
      })
      .addCase(getCompanyDocumentsByCompanyIdAndEmailData.pending, (state) => {
        state.isCompanyDocumentsLoading = true;
      })
      .addCase(
        getCompanyDocumentsByCompanyIdAndEmailData.fulfilled,
        (state, action) => {
          state.isCompanyDocumentsLoading = false;
          state.companyUserDocumentsData = action?.payload;
        },
      )
      .addCase(
        getCompanyDocumentsByCompanyIdAndEmailData.rejected,
        (state, action) => {
          logErrorWithPayload(action?.error);
          state.isCompanyDocumentsLoading = false;
        },
      )
      .addCase(addCompanyFolderData.pending, (state, action) => {
        state.companyFoldersLoader = true;
      })
      .addCase(addCompanyFolderData.fulfilled, (state, action) => {
        state.companyFoldersLoader = false;
        state.companyFolders = action?.payload;
      })
      .addCase(addCompanyFolderData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.companyFoldersLoader = false;
      })
      .addCase(renameCompanyFolderData.pending, (state) => {
        state.isRenameCompanyFolderLoading = true;
      })
      .addCase(renameCompanyFolderData.fulfilled, (state) => {
        state.isRenameCompanyFolderLoading = false;
      })
      .addCase(renameCompanyFolderData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isRenameCompanyFolderLoading = false;
      })
      .addCase(getCompanyFoldersByCompanyIdData.pending, (state, action) => {
        state.companyFoldersLoader = true;
      })
      .addCase(getCompanyFoldersByCompanyIdData.fulfilled, (state, action) => {
        state.companyFoldersLoader = false;
      })
      .addCase(getCompanyFoldersByCompanyIdData.rejected, (state, action) => {
        state.companyFoldersLoader = false;
      })
      .addCase(getDocumentsAnalyticsByCompanyIdData.pending, (state) => {
        state.isDocumentsAnalyticsLoading = true;
      })
      .addCase(
        getDocumentsAnalyticsByCompanyIdData.fulfilled,
        (state, action) => {
          state.isDocumentsAnalyticsLoading = false;
          state.documentsAnalytics = action?.payload;
        },
      )
      .addCase(
        getDocumentsAnalyticsByCompanyIdData.rejected,
        (state, action) => {
          logErrorWithPayload(action?.error);
          state.isDocumentsAnalyticsLoading = false;
        },
      )
      .addCase(
        getDocumentsOverallCompliancesByCompanyIdData.pending,
        (state) => {
          state.isDocumentsOverallComplianceLoading = true;
        },
      )
      .addCase(
        getDocumentsOverallCompliancesByCompanyIdData.fulfilled,
        (state, action) => {
          state.isDocumentsOverallComplianceLoading = false;
          state.documentsOverallCompliance = action?.payload;
        },
      )
      .addCase(
        getDocumentsOverallCompliancesByCompanyIdData.rejected,
        (state, action) => {
          logErrorWithPayload(action?.error);
          state.isDocumentsOverallComplianceLoading = false;
        },
      )
      .addCase(
        getDocumentsMembersCompliancesByCompanyIdData.pending,
        (state) => {
          state.isDocumentsMembersComplianceLoading = true;
        },
      )
      .addCase(
        getDocumentsMembersCompliancesByCompanyIdData.fulfilled,
        (state, action) => {
          state.isDocumentsMembersComplianceLoading = false;
          state.documentsMembersCompliance = action?.payload;
        },
      )
      .addCase(
        getDocumentsMembersCompliancesByCompanyIdData.rejected,
        (state, action) => {
          logErrorWithPayload(action?.error);
          state.isDocumentsMembersComplianceLoading = false;
        },
      )
      .addCase(viewCompanyDocumentData.pending, (state, action) => {
        state.viewDocumentLoader = true;
      })
      .addCase(viewCompanyDocumentData.fulfilled, (state, action) => {
        state.viewDocumentLoader = false;
      })
      .addCase(viewCompanyDocumentData.rejected, (state, action) => {
        state.viewDocumentLoader = false;
      })
      .addCase(updateCompanyDocumentData.pending, (state, action) => {
        state.isAddDocumentLoading = true;
      })
      .addCase(updateCompanyDocumentData.fulfilled, (state, action) => {
        state.isAddDocumentLoading = false;
      })
      .addCase(updateCompanyDocumentData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isAddDocumentLoading = false;
      })
      .addCase(
        getAllCompanyDocumentsByCompanyIdData.pending,
        (state, action) => {
          state.isGetAllCompanyDocumentsLoading = true;
        },
      )
      .addCase(
        getAllCompanyDocumentsByCompanyIdData.fulfilled,
        (state, action) => {
          state.isGetAllCompanyDocumentsLoading = false;
          state.allCompanyDocuments = action?.payload;
        },
      )
      .addCase(
        getAllCompanyDocumentsByCompanyIdData.rejected,
        (state, action) => {
          logErrorWithPayload(action?.error);
          state.isGetAllCompanyDocumentsLoading = false;
        },
      )
      .addCase(getCompayDocumentByIdData.pending, (state, action) => {
        state.isGetCompayDocumentByIdLoading = true;
      })
      .addCase(getCompayDocumentByIdData.fulfilled, (state, action) => {
        state.isGetCompayDocumentByIdLoading = false;
        state.patientCompanyDocument = action?.payload;
      })
      .addCase(getCompayDocumentByIdData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isGetCompayDocumentByIdLoading = false;
      })
      .addCase(deleteCompanyDocumentsData.pending, (state, action) => {
        state.isDeleteCompanyDocumentsLoading = true;
      })
      .addCase(deleteCompanyDocumentsData.fulfilled, (state, action) => {
        state.isDeleteCompanyDocumentsLoading = false;
        state.deleteCompanyDocuments = action?.payload;
      })
      .addCase(deleteCompanyDocumentsData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isDeleteCompanyDocumentsLoading = false;
      });
  },
});

export const { setIsCompanyDocumentLoadingData } = companyDocumentSlice.actions;

export default companyDocumentSlice.reducer;
